// The extra failed rows are only requested when entering the unme recovery flow.
export function isUnmePaymentRecovery(search) {
  return process.env.REACT_APP_UNME_FALLBACK_ENABLED === '1'
    && new URLSearchParams(search || '').get('includeFailed') === 'true';
}

export function withUnmePaymentRecoveryParams(params, search) {
  return isUnmePaymentRecovery(search) ? { ...params, includeFailed: true } : params;
}

export function getUnmePaymentRecoveryPath(domain) {
  return domain === 'cp'
    ? '/cp/integrated-settlement?view=payment&includeFailed=true'
    : '/app/payment-list?includeFailed=true';
}
